import { LitElement, html } from "lit";

import { customElement, property } from "lit/decorators.js";

import "ui-components/modal/wow-modal";

import { styles } from "./subscriber-emails-modal.css";
interface SubscriberEmail {
  email: string;
}

@customElement("subscriber-emails-modal")
export class SubscriberEmailsModal extends LitElement {
  @property({ type: Boolean }) open = false;
  @property({ type: Array }) emails: SubscriberEmail[] = [];
  @property({ type: Number }) total: number = 0;

  static override styles = styles;

  private handleSubscriberEmailsModalClose() {
    this.open = false;
    this.dispatchEvent(new CustomEvent("modal-closed", { bubbles: true, composed: true }));
  }

  protected override render() {
    return html`
      <wow-modal variant="responsive" hide-top-padding @close=${this.handleSubscriberEmailsModalClose}>
        <span slot="header">${this.total} Fans</span>
        <ul class="subscribers-list">
          ${this.emails.map(
            ({ email }) =>
              html`<li class="subscribers-list-item">
                <span class="subscribers-list-icon">
                  <ph-user size="24"></ph-user>
                </span>
                <p style="margin: 0;">${email}</p>
              </li>`,
          )}
        </ul>
      </wow-modal>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "subscriber-emails-modal": SubscriberEmailsModal;
  }
}
